import { Box, TableCell, TableRow, Typography } from "@mui/material";
import PropTypes from "prop-types";

import ModalBox from "components/ModalBox";
import TableWrapper from "components/TableWrapper";
import StatusChip from "components/StatusChip";
import ButtonV1 from "components/ButtonV1";
import { WORKING_HOURS_FAILED_ROW_COLUMNS } from "constants/eddConfig";

// backend sends flags as boolean or "true"/"false" strings
const formatCell = (value) => {
  if (value === true || value === "true") return "Yes";
  if (value === false || value === "false") return "No";
  return value ?? "-";
};

const RowResultDialog = ({
  open,
  title,
  result,
  onClose,
  columns = WORKING_HOURS_FAILED_ROW_COLUMNS,
}) => {
  const { successCount = 0, failedCount = 0, failedRows = [] } = result || {};

  const tableHeader = columns.map((col) => (
    <TableCell
      key={col.field}
      sx={{ whiteSpace: "nowrap", minWidth: col.minWidth }}
    >
      {col.headerName}
    </TableCell>
  ));

  const tableBody = failedRows.map((row, idx) => (
    <TableRow key={idx}>
      {columns.map((col) => (
        <TableCell key={col.field} sx={{ fontSize: "0.85rem", py: 1 }}>
          {formatCell(row[col.field])}
        </TableCell>
      ))}
    </TableRow>
  ));

  return (
    <ModalBox open={open} onCloseModal={onClose} width="60%">
      <Box>
        <Box display="flex" alignItems="center" gap={4} mb={2} pr={10}>
          <Typography fontSize={18} fontWeight="bold">
            {title}
          </Typography>
          <StatusChip label={`${successCount} saved`} type="SUCCESS" />
          <StatusChip label={`${failedCount} failed`} type="ERROR" />
        </Box>
        <Typography fontSize={14} color="text.secondary" mb={4}>
          Below rows were not saved. Fix them and try again.
        </Typography>
        <TableWrapper tableHeader={tableHeader} tableBody={tableBody} />
        <Box display="flex" justifyContent="flex-end" mt={4}>
          <ButtonV1 title="Close" size="small" onClick={onClose} />
        </Box>
      </Box>
    </ModalBox>
  );
};

RowResultDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  result: PropTypes.shape({
    successCount: PropTypes.number,
    failedCount: PropTypes.number,
    failedRows: PropTypes.arrayOf(PropTypes.object),
  }),
  onClose: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default RowResultDialog;
